<div class="d-flex flex-row">
  <button type="button"
    class="btn btn-outline-primary d-flex flex-row align-items-center justify-content-center morefilters"
    (click)="isCollapsed.set(!isCollapsed())" [disabled]="!promiseResult?.results" [attr.aria-expanded]="!isCollapsed()"
    aria-controls="collapseExample">
    <mat-icon>{{statusMoreFilters()}}</mat-icon>
    {{'filters' | translate}}
  </button>
  <div class="ngcollapse" #collapse="ngbCollapse" [horizontal]="true" [ngbCollapse]="!isCollapsed()">
    @if (promiseResult?.results) {
      <div class="d-flex bodycollapse justify-content-around">
        <div class="d-flex flex-column align-items-center">
          <mat-form-field class="form-field" appearance="outline">
            <input matInput type="text" [ngModel]="searchmodel()" (ngModelChange)="searchmodel.set($event)"
              placeholder="{{'component-searchbar-research' | translate}}">
            @if (searchmodel()) {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="searchmodel.set('')">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
          <div class="matchips d-flex flex-row">
            <mat-chip-listbox aria-label="id-selection">
              @for (cat of getLKeysSearch(); track cat) {
                <mat-chip-option (selectionChange)="changeSelected($event, cat)">
                  {{cat}}
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
          @if (!checkSearch()) {
            <p class="alert-search">{{'filters-search-error' | translate}}</p>
          }
        </div>
        <div ngbDropdown #sdkVersion="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="sdkversion" ngbDropdownAnchor
            (focus)="sdkVersion.open()">
            <img class="iconWP" src="assets/icons/BrowserAttestations/logoWP.png">
            <p>{{'browser-attestations-filter-sdk-version' | translate}}</p>
          </button>
          <div ngbDropdownMenu aria-labelledby="sdkversion">
            <button ngbDropdownItem #None value="None" (click)="resetSimpleForm(formSdkVersions)">
              {{'none' | translate}}
            </button>
            @for (sdk of getSdkVersions(); track sdk) {
              <mat-checkbox class="text-capitalize d-flex align-self-center"
                [(ngModel)]="formSdkVersions.value[sdk]">
                @if (sdk.length < 19) {
                  <p>{{sdk}}</p>
                } @else {
                  <p type="button" placement="right" [ngbTooltip]="sdk">{{formatLongString(sdk,19)}}</p>
                }
              </mat-checkbox>
            }
          </div>
        </div>
        <div ngbDropdown #Application="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="application" ngbDropdownAnchor
            (focus)="Application.open()">
            {{'browser-attestations-filter-applications' | translate}}
          </button>
          <div ngbDropdownMenu aria-labelledby="application">
            @if (!formApplications.disabled) {
              <button ngbDropdownItem #None value="None" (click)="resetSimpleForm(formApplications)">
                {{'none' | translate}}
              </button>
            }
            @for (application of getApplications(); track application) {
              <mat-checkbox [disabled]="formApplications.disabled" class="text-capitalize d-flex align-self-center"
                [(ngModel)]="formApplications.value[application]">
                <p>{{formatVersionFiltre(application)}}</p>
              </mat-checkbox>
            }
          </div>
        </div>
        <div ngbDropdown #Os="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="os" ngbDropdownAnchor (focus)="Os.open()">
            <p>{{'browser-attestations-filter-os' | translate}}</p>
          </button>
          <div ngbDropdownMenu aria-labelledby="os">
            <button ngbDropdownItem #None value="None"
              (click)="resetFormAndSubForm(formOs,formOsVersion);">
              {{'none' | translate}}
            </button>
            @for (os of getAllOsNames(); track os) {
              <mat-checkbox class="text-capitalize d-flex align-self-center"
                (change)="initFormVersionOs(os)" [indeterminate]="someCompleteForValue(formOsVersion,os)"
                [(ngModel)]="formOs.value[os]" [checked]="formOs.value[os]">
                <div class="d-flex flex-row align-items-center">
                  <img class="osIcon" src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">
                  <p>{{os}}</p>
                </div>
              </mat-checkbox>
              @if (formOs.value[os] && getAllVersionsForOs(os).length > 0) {
                <div class="dropdown-divider"></div>
                <div class="d-flex flex-row align-items-center sectionoshead">
                  <h5>{{'filters-versions-os' | translate}}</h5>
                  <img class="osIcon" src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">
                </div>
                @for (osVersion of getAllVersionsForOs(os); track osVersion) {
                  <mat-checkbox (change)="checkIfnoVersionInSubForm(formOs, formOsVersion, os)"
                    [(ngModel)]="formOsVersion.value[os][osVersion]"
                    (ngModelChange)="updateAllCompleteForm(formOs, formOsVersion, os)"
                    class="text-capitalize d-flex align-self-center">
                    {{formatVersionFiltre(osVersion)}}
                  </mat-checkbox>
                }
              }
            }
          </div>
        </div>
        <div ngbDropdown #Browser="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="browser" ngbDropdownAnchor (focus)="Browser.open()">
            <img src="assets/icons/BrowserAttestations/browser.svg">
            <p>{{'browser-attestations-filter-browser' | translate}}</p>
          </button>
          <div ngbDropdownMenu aria-labelledby="browser">
            <button ngbDropdownItem #None value="None"
              (click)="resetFormAndSubForm(formBrowser,formBrowserVersion);">
              {{'none' | translate}}
            </button>
            @for (browser of getAllBrowserNames(); track browser) {
              <mat-checkbox class="text-capitalize d-flex align-self-center"
                (change)="initFormVersionBrowser(browser)" [indeterminate]="someCompleteForValue(formBrowserVersion,browser)"
                [(ngModel)]="formBrowser.value[browser]" [checked]="formBrowser.value[browser]">
                <div class="d-flex flex-row align-items-center">
                  <img class="browserIcon" src="assets/icons/BrowserAttestations/browsers/{{browser.toLowerCase() | browser}}.svg">
                  <p>{{browser}}</p>
                </div>
              </mat-checkbox>
              @if (formBrowser.value[browser] && getAllVersionsForBrowser(browser).length > 0) {
                <div class="dropdown-divider"></div>
                <div class="d-flex flex-row align-items-center sectionoshead">
                  <h5>{{'filters-versions-of' | translate}}</h5>
                  <img class="browserIcon" src="assets/icons/BrowserAttestations/browsers/{{browser.toLowerCase() | browser}}.svg">
                </div>
                @for (browserVersion of getAllVersionsForBrowser(browser); track browserVersion) {
                  <mat-checkbox (change)="checkIfnoVersionInSubForm(formBrowser, formBrowserVersion, browser)"
                    [(ngModel)]="formBrowserVersion.value[browser][browserVersion]"
                    (ngModelChange)="updateAllCompleteForm(formBrowser, formBrowserVersion, browser)"
                    class="text-capitalize d-flex align-self-center">
                    {{formatVersionFiltre(browserVersion)}}
                  </mat-checkbox>
                }
              }
            }
          </div>
        </div>
        <button type="button" [disabled]="!checkSearch()" (click)="applyFilters()"
          class="search btn btn-outline-success">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    }
  </div>
</div>